import { Link } from 'react-router-dom';
import useHasLegacyNps from 'studio5/hooks/use-has-legacy-nps';
import ButtonLink from './ButtonLink';

export default function LegacyNpsButton() {
  const hasLegacyNps = useHasLegacyNps();

  if (!hasLegacyNps) {
    return null;
  }

  return (
    <ButtonLink forwardedAs={Link} to="/nps" variant="secondary">
      Go to legacy NPS
    </ButtonLink>
  );
}
